import React, {Suspense} from "react";
import {Redirect, Switch} from "react-router-dom";
import {ContentRoute, LayoutSplashScreen} from "../../_metronic/layout";
import {DashboardPage} from "../admin/dashboard/DashboardPage";
import Orders from "../admin/orders";
import Baskets from "../admin/baskets";
import Factors from "../admin/Factors";
import FactorShow from "../admin/Factors/FactorShow";
import FactorsCreate from "../admin/Factors/FactorCreate"
import ProductEditIndex from "../admin/products/product-edit";
import Products from "../admin/products";


export default function AdminPages() {
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/admin/dashboard"/>
                }
                <ContentRoute path="/admin/dashboard" component={DashboardPage}/>
                <ContentRoute path="/admin/orders" component={Orders}/>
                <ContentRoute path="/admin/baskets" component={Baskets}/>
                <ContentRoute path="/admin/products/:id" component={ProductEditIndex}/>
                <ContentRoute path="/admin/products" component={Products}/>
                <ContentRoute path="/admin/factors/create" component={FactorsCreate}/>
                <ContentRoute path="/admin/factors/:id" component={FactorShow}/>
                <ContentRoute path="/admin/factors" component={Factors}/>

            </Switch>
        </Suspense>
    );
}
